<div id="myModal" class="modal">
    <div
        class="tw-cursor-pointer tw-flex tw-text-center tw-justify-end tw-text-white tw-text-[35px] tw-font-bold tw-mt-[30px] tw-mr-[30px]"
        (click)="closeModal()"
    >
        <span>X</span>
    </div>
    <div class="modal-content">
        <iframe style="height: 100%; width: 100%" title="Chatbot-Modal-Content"></iframe>
    </div>
</div>